import { render, staticRenderFns } from "./teamScreen.vue?vue&type=template&id=432ef0b0&scoped=true"
import script from "./teamScreen.vue?vue&type=script&lang=js"
export * from "./teamScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432ef0b0",
  null
  
)

export default component.exports